import { render, staticRenderFns } from "./EventComponent.vue?vue&type=template&id=3158d9b1&scoped=true&"
import script from "./EventComponent.vue?vue&type=script&lang=ts&"
export * from "./EventComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EventComponent.vue?vue&type=style&index=0&id=3158d9b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158d9b1",
  null
  
)

export default component.exports